module.exports = __webpack_public_path__ + "static/img/00049A_C_2_4_5_20180322_LC.147f054.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/00049A_C_2_4_5_20180322_LC.png
// module id = thI7
// module chunks = 0